/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_RulesInputs */

const th_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กติกาและข้อมูล`)
};

const en_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rules & info`)
};

const ja_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大会規定`)
};

const zh_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`规则与信息`)
};

const es_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normas e información`)
};

const pt_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regras e informações`)
};

const id_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aturan dan info`)
};

const fr_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Règlement et infos`)
};

const tl_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panuntunan at impormasyon`)
};

const vi_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều lệ và thông tin`)
};

const ko_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`규정 및 안내`)
};

const de_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regeln und Infos`)
};

const ru_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Правила и информация`)
};

const tr_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurallar ve bilgi`)
};

const it_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regolamento e informazioni`)
};

const pl_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regulamin i informacje`)
};

const uk_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Правила та інформація`)
};

const hi_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नियम और जानकारी`)
};

const ar_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اللوائح والمعلومات`)
};

const ms_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peraturan dan maklumat`)
};

const bn_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিয়ম ও তথ্য`)
};

const zh_tw2_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`規則與資訊`)
};

const zh_hk2_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`規則與資訊`)
};

const ur_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قواعد اور معلومات`)
};

const fa_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قوانین و اطلاعات`)
};

const sw_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanuni na taarifa`)
};

const nl_tab_rules = /** @type {(inputs: Tab_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reglement en info`)
};

/**
* | output |
* | --- |
* | "Rules & info" |
*
* @param {Tab_RulesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_rules = /** @type {((inputs?: Tab_RulesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_RulesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_tab_rules(inputs)
	if (locale === "ja") return ja_tab_rules(inputs)
	if (locale === "zh") return zh_tab_rules(inputs)
	if (locale === "es") return es_tab_rules(inputs)
	if (locale === "pt") return pt_tab_rules(inputs)
	if (locale === "id") return id_tab_rules(inputs)
	if (locale === "fr") return fr_tab_rules(inputs)
	if (locale === "tl") return tl_tab_rules(inputs)
	if (locale === "vi") return vi_tab_rules(inputs)
	if (locale === "ko") return ko_tab_rules(inputs)
	if (locale === "de") return de_tab_rules(inputs)
	if (locale === "ru") return ru_tab_rules(inputs)
	if (locale === "tr") return tr_tab_rules(inputs)
	if (locale === "it") return it_tab_rules(inputs)
	if (locale === "pl") return pl_tab_rules(inputs)
	if (locale === "uk") return uk_tab_rules(inputs)
	if (locale === "hi") return hi_tab_rules(inputs)
	if (locale === "ar") return ar_tab_rules(inputs)
	if (locale === "ms") return ms_tab_rules(inputs)
	if (locale === "bn") return bn_tab_rules(inputs)
	if (locale === "zh-TW") return zh_tw2_tab_rules(inputs)
	if (locale === "zh-HK") return zh_hk2_tab_rules(inputs)
	if (locale === "ur") return ur_tab_rules(inputs)
	if (locale === "fa") return fa_tab_rules(inputs)
	if (locale === "sw") return sw_tab_rules(inputs)
	if (locale === "nl") return nl_tab_rules(inputs)
	return en_tab_rules(inputs)
});